import React from "react";
import "./OpenPositionDetailsBanner.css";
import RichTextContent, { CmsText } from "../../../RichTextContent/RichTextContent";

import bg from "../../../../assets/images/services/hero.png";

const OpenPositionDetailsBanner = ({ job }) => {
  if (!job) return null;

  return (
    <section className="job-banner">

      {/* BG */}
      <img src={bg} alt="" className="job-banner__bg" />

      {/* OVERLAY */}
      <div className="job-banner__overlay" />

      {/* CONTENT */}
      <div className="job-banner__content">

        <span className="job-banner__label">
          Open position
        </span>

        <CmsText content={job.title} as="h1" />
        <RichTextContent content={job.description} />

        <div className="job-banner__tags">
          <CmsText content={job.location} as="span" />
          <CmsText content={job.type} as="span" />
        </div>

      </div>

    </section>
  );
};

export default OpenPositionDetailsBanner;